import React, { useState } from "react";
import {
  Box,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Grid,
} from "@mui/material";
import { Visibility } from "@mui/icons-material";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";

import "./Queue.css";

function Queue() {
  const [addresses] = useState([
    {
      ticketId: "TCK-1023",
      department: "IT",
      employeeId: "EMP001",
      employeeName: "Rahul Kumar",
      description: "System login issue",
      status: "Open",
      remarks: "High Priority",
      closedDate: "-",
      feedback: "Pending",
    },
  ]);

  const [selectedRows, setSelectedRows] = useState([]);
  const [openView, setOpenView] = useState(false);
  const [viewData, setViewData] = useState(null);

  const isAllSelected =
    addresses.length > 0 && selectedRows.length === addresses.length;

  const handleSelectAll = () => {
    setSelectedRows(isAllSelected ? [] : addresses.map((_, i) => i));
  };

  const handleSelect = (index) => {
    setSelectedRows((prev) =>
      prev.includes(index)
        ? prev.filter((i) => i !== index)
        : [...prev, index]
    );
  };

  const handleView = (row) => {
    setViewData(row);
    setOpenView(true);
  };

  const handleExport = () => {
    console.log("Export clicked");
  };

  return (
    <div className="queue-wrapper">
      {/* HEADER */}
      <div className="queue-header">
        <h2>Ticket Queue</h2>

        <Button
          className="export-btn"
          startIcon={<CloudDownloadIcon />}
          onClick={handleExport}
        >
          Export
        </Button>
      </div>

      {/* TABLE */}
      <TableContainer component={Paper} className="queue-table-container">
        <Table stickyHeader>
          <TableHead>
            <TableRow className="queue-table-head">
              <TableCell align="center">
                <Checkbox checked={isAllSelected} onChange={handleSelectAll} />
              </TableCell>

              {[
                "Ticket ID",
                "Department",
                "Employee ID",
                "Employee Name",
                "Issue Description",
                "Status",
                "Remarks",
                "Closed Date",
                "Feedback",
                "View",
              ].map((head) => (
                <TableCell key={head} align="center">
                  {head}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {addresses.map((row, index) => (
              <TableRow key={index} hover>
                <TableCell align="center">
                  <Checkbox
                    checked={selectedRows.includes(index)}
                    onChange={() => handleSelect(index)}
                  />
                </TableCell>

                <TableCell align="center">{row.ticketId}</TableCell>
                <TableCell align="center">{row.department}</TableCell>
                <TableCell align="center">{row.employeeId}</TableCell>
                <TableCell align="center">{row.employeeName}</TableCell>
                <TableCell align="center">{row.description}</TableCell>
                <TableCell align="center">
                  <span className={`status ${row.status.toLowerCase()}`}>
                    {row.status}
                  </span>
                </TableCell>
                <TableCell align="center">{row.remarks}</TableCell>
                <TableCell align="center">{row.closedDate}</TableCell>

                {/* FEEDBACK */}
                <TableCell align="center">
                  <ThumbUpIcon className="thumb-up" />
                  <ThumbDownIcon className="thumb-down" />
                </TableCell>

                {/* VIEW */}
                <TableCell align="center">
                  <IconButton
                    color="primary"
                    onClick={() => handleView(row)}
                  >
                    <Visibility fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* VIEW POPUP */}
      <Dialog
        open={openView}
        onClose={() => setOpenView(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle className="view-title">
          Ticket Details
        </DialogTitle>

        <DialogContent>
          {viewData && (
            <Grid container spacing={2} className="view-grid">
              <Grid item xs={6}>
                <Typography><b>Ticket ID:</b> {viewData.ticketId}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography><b>Status:</b> {viewData.status}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography><b>Department:</b> {viewData.department}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography><b>Employee ID:</b> {viewData.employeeId}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography><b>Employee Name:</b> {viewData.employeeName}</Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography><b>Description:</b> {viewData.description}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography><b>Remarks:</b> {viewData.remarks}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography><b>Feedback:</b> {viewData.feedback}</Typography>
              </Grid>
            </Grid>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}

export default Queue;
